import React from "react";
import * as styled from "./styled";

const CustomDataCard = ({ fieldName, value }: { key: string, fieldName: string; value: string }) => {
  return (
    <styled.CustomDataCardWrapper>
      <styled.CustomDataFieldName>{fieldName}</styled.CustomDataFieldName>
      <p>{value}</p>
    </styled.CustomDataCardWrapper>
  );
};

export default CustomDataCard;
